<template>
  <div style="height: 50px; width: 100%">
    <Bar
      :chart-id="chartid"
      :chart-options="chartOptions"
      :chart-data="chartData"
      :height="50"
      :width="400"
    />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  BarElement,
  CategoryScale,
} from 'chart.js'

ChartJS.register(Title, Tooltip, BarElement, CategoryScale)

export default {
  name: 'BarChart',
  components: { Bar },
  props: {
    targetDataBase: {
      type: Number
    },
  },
  data() {
    return {
      chartid: 'curid-'+Math.random(),
      chartData: {
        labels: [ 'Baseline %' ],
        datasets: [ { data: [this.targetDataBase], barThickness: 50 } ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        height: 50,
        layout: {
            padding: 0
        },
        indexAxis: 'y',
        plugins: {
          legend: {
            display: false
          },
          title: {
            display: false
          }
        },
        scales: {
          x: {
            min: 0,
            max: 100,
            reverse: true,
            grid: {
                display: false,
                drawBorder: false
            },
            ticks: {
                display: false
            }
          },
          y: {
            display: false,
            grid: {
                display: false,
                drawBorder: false
            }
          }
        }
      }
    }
  },
  watch: {
    targetDataBase: {
      handler(newValue) {
        this.chartData.datasets[0].data = [newValue];
      },
      immediate: true
    }
  }
}
</script>